import React from 'react';
import ContactsIcon from '@material-ui/icons/Contacts';
import AppNavButton from './Components/AppNavButton';

const ContractManagementNav = () => {
	return (
		<AppNavButton text="Contract Management" showGroupingMenu={true} path="/contractmanagement" icon={<ContactsIcon />} />
	);
};

export default ContractManagementNav;
